
import { toProxy } from "../watcher";
import { TranslationGlobalConfig } from "./types";
import { Log } from "../log";

// 文件级别log
const fileLog = new Log(false, 'TranslationGlobalData_file');
fileLog.pause = true;

/**
 * 全局翻译配置
 * 使用toProxy创建响应式对象
 */
export const translationGlobalConfig = toProxy<TranslationGlobalConfig>({
  auto: true,
});

// 初始化log
const initLog = fileLog.sub(false, 'init_fn');
initLog.pause = true;
initLog.log('translationGlobalConfig created', translationGlobalConfig);
